/**
 * Utility for tracking and displaying notifications with counters for repeated actions
 */

const recentlyAddedItems = {};
const NOTIFICATION_TIMEOUT = 12000; // 12 seconds window for considering "quick succession"

/**
 * Show a notification with counter for repeated actions
 * @param {Object} vue - Vue instance with $notify method
 * @param {String} itemId - Unique identifier for the item
 * @param {String} itemName - Name of the item to display in notification
 * @param {String} group - Notification group name
 * @param {Function} translateFn - Translation callback (count, itemName) => translatedString (optional)
 */
export function showNotificationWithCounter(
    vue,
    itemId,
    itemName,
    group = 'PiggyRewards',
    translateFn = null
) {
    const currentTime = Date.now();

    if (recentlyAddedItems[itemId]) {
        vue.$notify.close(`item-${itemId}`);
    }

    if (
        recentlyAddedItems[itemId] &&
        currentTime - recentlyAddedItems[itemId].timestamp <
            NOTIFICATION_TIMEOUT
    ) {
        recentlyAddedItems[itemId].count++;
        recentlyAddedItems[itemId].timestamp = currentTime;

        const title = translateFn
            ? translateFn(recentlyAddedItems[itemId].count, itemName)
            : `${recentlyAddedItems[itemId].count}x ${itemName} added to your basket`;

        vue.$notify({
            group,
            title,
            duration: 5000,
            id: `item-${itemId}` // Use consistent ID for this item
        });
    } else {
        recentlyAddedItems[itemId] = {
            count: 1,
            timestamp: currentTime
        };

        const title = translateFn
            ? translateFn(1, itemName)
            : `${itemName} added to your basket`;

        vue.$notify({
            group,
            title,
            duration: 5000,
            id: `item-${itemId}` // Use consistent ID for this item
        });
    }

    setTimeout(() => {
        delete recentlyAddedItems[itemId];
    }, NOTIFICATION_TIMEOUT);
}
